import { inject } from "@angular/core"
import { Router, Routes } from "@angular/router"
import { ERoutes } from "./modules/shared/constants/routes.enum"
import { supportedLanguagesMatch } from "./modules/i18n/guards/supported-languages.guard"
import { localeResolver } from "./modules/i18n/resolvers/locale.resolver"
import { HomeComponent } from "./modules/home/screens/home/home.component"
import { TermsConditionsScreenComponent } from "./modules/test/screens/terms-conditions-screen/terms-conditions-screen.component"
import { SpotsComponent } from "./modules/spots/components/screens/spots/spots.component"
import { SpotDetailsComponent } from "./modules/spots/components/screens/spot-details/spot-details.component"
import { InsightComponent } from "./modules/insight/components/screens/insight/insight.component"
import { HubComponent } from "./modules/hub/components/screens/hub/hub.component"
import { AboutComponent } from "./modules/about/screens/about/about.component"

export const pageRoutes: Routes = [
      {
        path: ERoutes.HOME,
        pathMatch: "full",
        component: HomeComponent,
        resolve: [localeResolver],
        data: {
          title: "Home",
        },
      },
      {
        path: ERoutes.TERMS,
        component: TermsConditionsScreenComponent,
        resolve: [localeResolver],
        data: {
          title: "Privacy Policy and Terms of Use",
        },
      },
      {
        path: ERoutes.INSIGHT,
        component: InsightComponent,
        resolve: [localeResolver],
        data: {
          title: "Insight",
        },
      },
      {
        path: ERoutes.HUB,
        component: HubComponent,
        resolve: [localeResolver],
        data: {
          title: "Hub",
        },
      },
      {
        path: ERoutes.ABOUT,
        component: AboutComponent,
        resolve: [localeResolver],
        data: {
          title: "About",
        },
      },
      {
        path: ERoutes.SPOTS,
        component: SpotsComponent,
        resolve: [localeResolver],
        data: {
          title: "Spots",
        },
      },
      {
        path: ERoutes.SPOT_DETAILS,
        component: SpotDetailsComponent,
        resolve: [localeResolver],
        data: {
          title: "Spot Details",
        },
      },
      // Retired RTR URLs and unknown paths always return to LENS.
      { path: "**", redirectTo: ERoutes.HOME },
]

export const routes: Routes = [
  {
    path: "en",
    children: [{
      path: "**",
      redirectTo: ({ url, queryParams, fragment }) => inject(Router).createUrlTree(
        ["/", ...url.map(segment => segment.path)], { queryParams, fragment: fragment ?? undefined }
      ),
    }],
  },
  { path: ":lang", canMatch: [supportedLanguagesMatch], children: pageRoutes },
  { path: "", children: pageRoutes },
]
